import { render, staticRenderFns } from "./HeraDummyList.vue?vue&type=template&id=de107634&"
import script from "./HeraDummyList.vue?vue&type=script&lang=js&"
export * from "./HeraDummyList.vue?vue&type=script&lang=js&"
import style0 from "./HeraDummyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports